import './index.scss'
$(document).ready(function () {
    $('.section1 .banner .swiper-slide').addClass('swiper-slide-active')
  });
  $(function(){
    var s_title=$(".r_i .r_i_set");
    var s_select=$(".se_i li");
    
    s_title.click(function(e){
      $(this).addClass("span_aa");
      $(this).siblings("ul").slideDown();
      e.stopPropagation();
      });		
      
    s_select.click(function(){
      var s_text=$(this).html();
      var s_title_2=$(this).parent('ul').siblings(".r_i_set").children('span');
      s_title_2.html(s_text).removeClass("span_aa")
      $(".r_i .r_i_set").addClass("span_color")
      $(this).parent('ul').slideUp();
      });
      
    $(document).click(function(){
      s_title.removeClass("span_aa");
      $(".r_i ul").hide();		
      });    
        
  });